import { Component, Input, OnInit } from '@angular/core';
import { Attachment, FinancialSnapshot } from '../../../models';

@Component({
    selector: 'rms-financial-snapshot',
    templateUrl: './financial-snapshot.component.html',
    styleUrls: ['./financial-snapshot.component.scss'],
    standalone: false
})
export class FinancialSnapshotComponent implements OnInit {

  @Input() data: FinancialSnapshot;
  @Input() attachments: Array<Attachment>;
  public defaultCurrency = 'USD';

  constructor() { }

  ngOnInit() {
  }

}
